export default __webpack_public_path__ + "static/media/nouvelle-affaire.ac904a62.svg";